import React from 'react'

function getMatchDetailsText(game) {
    let text = daysByNum[lang][game['day']];

    text += typeof game['hour'] != 'undefined' && game['hour'] ? ' | ' + game['hour'] : '';
    text += typeof game['stadiumId'] != 'undefined' && game['stadiumId'] ? ' | ' + getObjField(game['stadiumId']) : '';
    text += typeof game['broadcast'] != 'undefined' && game['broadcast'] ? ' | ' + game['broadcast'] : '';

    return text;
}

const Game = ({
    game
}) =>  {
    return (<div className="matchContainer">
        <div className="team-name-right teamNameGames text-left">
            <a href={getTeamLink(game.homeTeamId.id)} >
                { getObjField(game.homeTeamId) }
            </a>
        </div>

        <a href={getTeamLink(game.homeTeamId.id) }>
            <img data-src={ "https://static.football.co.il/wp-content/themes/kingclub-theme/images/teams/" + game.homeTeamId.id + ".png" }
                 src={ "https://static.football.co.il/wp-content/themes/kingclub-theme/images/teams/" + game.homeTeamId.id + ".png" }
                 title={getObjField(game.homeTeamId)}
                 className="team-logo-right teamLogoGames lazy" />
        </a>
        <div className="vsGames">
            <a href={getGameLink(game.id)} >
                <div className="vsNumber">{game.homeScore}</div>
                <div className="vsText"></div>
                <div className="vsNumber">{game.awayScore}</div>
                <div className="vsDivider"></div>
                <div className="matchDetailsGames">{getMatchDetailsText(game)}</div>
            </a>
        </div>
        <a href={getTeamLink(game.awayTeamId.id) } >
            <img data-src={"https://static.football.co.il/wp-content/themes/kingclub-theme/images/teams/" + game.awayTeamId.id + ".png" }
                 src={"https://static.football.co.il/wp-content/themes/kingclub-theme/images/teams/" + game.awayTeamId.id + ".png" }
                 title={getObjField(game.awayTeamId)}
                 className="team-logo-left teamLogoGames laz" />
        </a>
        <div className="teamNameGames text-right team-name-left">
            <a href={getTeamLink(game.awayTeamId.id)} >
                {getObjField(game.awayTeamId)}
            </a>
        </div>
    </div> )};


export default Game